import { c as _c } from "react/compiler-runtime";
import { Props as BrandsProps } from './brands.component';
import HeadlineComponent from '../headline/headline.component';
import { ReactElement } from 'react';
import placeholderStyles from '../placeholder/placeholder.component.module.scss';
import styles from './brands.component.module.scss';
export type Props = Pick<BrandsProps, 'componentId' | 'headline' | 'subHeadline' | 'headlineLink' | 'brandLogos'>;
export default function BrandsPlaceholderComponent(t0) {
  const $ = _c(12);
  const {
    componentId,
    headline,
    subHeadline,
    headlineLink,
    brandLogos
  } = t0;
  let t1;
  if ($[0] !== componentId || $[1] !== headline || $[2] !== headlineLink || $[3] !== subHeadline) {
    t1 = headline && <HeadlineComponent id={`${componentId}-placeholder-headline`} usedInFullWidthComponent={true} headline={headline} subHeadline={subHeadline} link={headlineLink} />;
    $[0] = componentId;
    $[1] = headline;
    $[2] = headlineLink;
    $[3] = subHeadline;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== brandLogos) {
    t2 = brandLogos.map(_temp);
    $[5] = brandLogos;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div><div className={styles.brands__images}>{t2}</div></div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className={styles.brands}>{t1}{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp(t0) {
  const {
    image
  } = t0;
  return <div className={styles["brands__placeholder-entry"]} key={image.src}><span className={`${styles["brands__placeholder-logo"]} ${placeholderStyles.placeholder}`} style={{
      width: image?.width ?? 111,
      aspectRatio: `${image?.width ?? 111} / ${image?.height ?? 65}`
    }} /></div>;
}